import React from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorScreen as BaseErrorScreen } from '@/js/libs/error-boundary';

interface ErrorScreenProps {
  error: Error;
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({ error }) => {
  const [t] = useTranslation(['backend', 'common', 'components']);

  return <BaseErrorScreen error={error} title={t('components:APP_ERROR')} />;
};

export default React.memo(ErrorScreen);
